import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../../atoms/CheckBox';

const CheckboxGroup = (props) => {
  const {
    name,
    type,
    inline,
    checkboxList,
    disabled,
    onChange,
  } = props;

  return (
    checkboxList.map((element) => (
      <Checkbox
        inline={inline}
        type={type}
        label={element.label}
        name={name}
        value={element.value}
        id={element.id}
        checked={element.isChecked}
        disabled={element.isDisabled || disabled}
        onChange={onChange || element.onChange}
        key={element.id}
      />
    ))
  );
};

CheckboxGroup.propTypes = {
  name: PropTypes.string,
  type: PropTypes.oneOf(['checkbox', 'radio', 'switch']),
  inline: PropTypes.bool,
  checkboxList: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      inline: PropTypes.bool,
      type: PropTypes.oneOf(['checkbox', 'switch', 'radio']),
      name: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
      ]),
      checked: PropTypes.bool,
      disabled: PropTypes.bool,
      onChange: PropTypes.func,
      id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    }),
  ).isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

CheckboxGroup.defaultsProps = {
  name: null,
  type: 'checkbox',
  inline: false,
  disabled: false,
  onChange: null,
};

export default CheckboxGroup;
